import ApiService from "./ApiService";
import GeneralUtils from '../utilities/GeneralUtils';

export class AdministrationService {

    async getHolidayList(year) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/holiday/list/${year}`)
                .then(response => {
                    response.data.map((item) => {
                        item.date = item.date ? new Date(Date.parse(item.date)) : '';
                        return item;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }    

    async saveHoliday(holiday) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/holiday', holiday)
                .then(response => {
                    response.data.date = response.data.date ? new Date(Date.parse(response.data.date)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async deleteHoliday(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/holiday/${id}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }
    
}